<div class="min-h-screen text-sm dark:bg-slate-900 p-4 md:p-8 text-slate-600 dark:text-slate-300">
  <!-- Header -->
  <div class="animate-fade-in flex flex-col md:flex-row md:items-end justify-between mb-6 gap-4">
    <div>
      <h1 class="text-3xl font-extrabold text-slate-800 dark:text-slate-100 tracking-tight">
        โควต้าจอดฟรี (ลาน / Client)
      </h1>
      <p class="text-slate-500 dark:text-slate-400 mt-2 font-medium">
        <ng-container *ngIf="selectedSiteName; else noSiteHint">
          ลาน <span class="font-bold text-amber-600">{{ selectedSiteName }}</span>
          · ตั้ง pool ของลาน แล้วแจกให้บริษัทผู้เช่า (Client)
        </ng-container>
        <ng-template #noSiteHint>เลือกลานจากแถบด้านข้างก่อน</ng-template>
      </p>
    </div>
    <div *ngIf="selectedSiteId" class="flex flex-col sm:flex-row items-center gap-3 w-full sm:w-auto">
      <button type="button" (click)="showGuide.set(!showGuide())"
        class="w-full sm:w-auto px-4 py-3 bg-white/95 dark:bg-slate-900/95 text-slate-600 rounded-2xl shadow-sm border border-slate-100/50 hover:text-amber-500 transition-all font-bold flex items-center justify-center gap-2">
        <span class="material-icons text-[18px]">help_outline</span>
        วิธีใช้
      </button>
      <button type="button" (click)="onRefresh()" title="รีเฟรช"
        class="w-full sm:w-auto p-3 bg-white/95 dark:bg-slate-900/95 text-slate-500 rounded-2xl shadow-sm border border-slate-100/50 hover:text-amber-500 transition-all flex items-center justify-center">
        <span class="material-icons">refresh</span>
      </button>
      <button *ngIf="canUpdate" type="button" (click)="openSiteQuotaModal()"
        class="w-full sm:w-auto px-5 py-3 bg-white dark:bg-slate-800 text-amber-600 font-bold rounded-2xl shadow-sm border border-amber-200 hover:bg-amber-50 transition-all flex items-center justify-center gap-2 cursor-pointer">
        <span class="material-icons text-[18px]">local_parking</span>
        ตั้งโควต้าลาน
      </button>
      <button *ngIf="canUpdate" type="button" (click)="openAllocateModal()"
        class="w-full sm:w-auto px-5 py-3 bg-amber-400 hover:bg-amber-500 text-white font-bold rounded-2xl shadow-lg shadow-amber-200/50 transition-all flex items-center justify-center gap-2 cursor-pointer">
        <span class="material-icons text-[18px]">add</span>
        แจกโควต้าให้ Client
      </button>
    </div>
  </div>

  <!-- No site -->
  <div *ngIf="!selectedSiteId"
    class="animate-fade-in bg-white/95 dark:bg-slate-900/95 rounded-[2rem] shadow-2xl border border-slate-100/50 py-20 text-center text-slate-400">
    <span class="material-icons text-5xl mb-2">place</span>
    <p class="font-bold">กรุณาเลือกลานจากแถบด้านข้าง</p>
  </div>

  <ng-container *ngIf="selectedSiteId">
    <!-- Guide -->
    <div *ngIf="showGuide()"
      class="animate-fade-in mb-6 grid grid-cols-1 md:grid-cols-3 gap-4">
      <div class="bg-white/95 dark:bg-slate-900/95 rounded-2xl p-5 border border-slate-100/50 shadow-sm">
        <p class="text-xs font-black text-amber-500 mb-1">ขั้นที่ 1</p>
        <p class="font-bold text-slate-700 dark:text-slate-200">ตั้งโควต้าลาน</p>
        <p class="text-xs text-slate-400 mt-1">กำหนดจำนวนจอดฟรีทั้งหมดของลานต่อประเภทรถ (pool)</p>
      </div>
      <div class="bg-white/95 dark:bg-slate-900/95 rounded-2xl p-5 border border-slate-100/50 shadow-sm">
        <p class="text-xs font-black text-amber-500 mb-1">ขั้นที่ 2</p>
        <p class="font-bold text-slate-700 dark:text-slate-200">แจกให้ Client</p>
        <p class="text-xs text-slate-400 mt-1">ค้นหาบริษัทผู้เช่า แล้วแจกจำนวน — หักจาก pool ของลานทันที</p>
      </div>
      <div class="bg-white/95 dark:bg-slate-900/95 rounded-2xl p-5 border border-slate-100/50 shadow-sm">
        <p class="text-xs font-black text-amber-500 mb-1">ขั้นที่ 3</p>
        <p class="font-bold text-slate-700 dark:text-slate-200">จัดการรายแถว</p>
        <p class="text-xs text-slate-400 mt-1">แก้จำนวน / เพิ่ม / คืนส่วนเหลือกลับลาน / ยกเลิก / ดูประวัติ</p>
      </div>
    </div>

    <!-- Site quota (pool) -->
    <div class="animate-fade-in bg-white/95 dark:bg-slate-900/95 backdrop-blur-sm rounded-[2rem] shadow-2xl border border-slate-100/50 overflow-hidden mb-6">
      <div class="p-6 border-b border-slate-100/50 flex items-center justify-between gap-4">
        <h3 class="text-lg font-bold text-slate-800 dark:text-slate-100 flex items-center gap-2">
          <span class="material-icons text-amber-500">local_parking</span>
          โควต้าลาน (pool)
        </h3>
        <span class="text-xs text-slate-400">{{ siteQuotas().length }} ประเภทรถ</span>
      </div>
      <div class="overflow-x-auto relative custom-scrollbar">
        <table class="w-full text-left border-collapse" [class.opacity-50]="isSiteLoading()">
          <thead class="bg-white/95 dark:bg-slate-900/95 border-b border-slate-100/50">
            <tr class="text-xs font-bold text-slate-400 uppercase tracking-widest">
              <th class="p-4">ประเภทรถ</th>
              <th class="p-4">แพ็กเกจ</th>
              <th class="p-4 text-right">อนุมัติ</th>
              <th class="p-4 text-right">ใช้ตรง</th>
              <th class="p-4 text-right">แจก Client</th>
              <th class="p-4 text-right">เหลือแจกได้</th>
              <th class="p-4">สถานะ</th>
              <th class="p-4 text-center w-[120px]">จัดการ</th>
            </tr>
          </thead>
          <tbody class="divide-y divide-slate-50 dark:divide-slate-800">
            <tr *ngFor="let q of siteQuotas(); trackBy: trackQuota"
              class="hover:bg-slate-50/50 dark:hover:bg-slate-800/50 transition-all">
              <td class="p-4 font-bold text-slate-700 dark:text-slate-200">{{ q.vehicleTypeName || q.vehicleTypeId }}</td>
              <td class="p-4 text-xs text-slate-500">{{ q.subscriptionName || '—' }}</td>
              <td class="p-4 text-right font-bold">{{ q.quotaApproved | number }}</td>
              <td class="p-4 text-right">{{ q.quotaUsed | number }}</td>
              <td class="p-4 text-right">{{ q.quotaAllocatedToClients | number }}</td>
              <td class="p-4 text-right">
                <span class="font-black"
                  [ngClass]="q.quotaRemainingPool > 0 ? 'text-emerald-600' : 'text-rose-500'">
                  {{ q.quotaRemainingPool | number }}
                </span>
              </td>
              <td class="p-4">
                <span class="inline-flex px-2.5 py-1 rounded-full text-xs font-semibold"
                  [ngClass]="q.status === 'active'
                    ? 'bg-emerald-50 text-emerald-700 dark:bg-emerald-900/30 dark:text-emerald-400'
                    : 'bg-slate-100 text-slate-500 dark:bg-slate-700 dark:text-slate-300'">
                  {{ statusLabel(q.status) }}
                </span>
              </td>
              <td class="p-4 text-center">
                <div class="inline-flex items-center gap-1.5">
                  <button type="button" (click)="openSiteHistory(q)" title="ดูประวัติ"
                    class="w-8 h-8 rounded-lg flex items-center justify-center border border-slate-100 hover:border-sky-400 text-slate-400 hover:text-sky-500 transition-all cursor-pointer">
                    <span class="material-icons text-base">history</span>
                  </button>
                  <button *ngIf="canUpdate" type="button" (click)="openSiteQuotaModal(q)" title="แก้ไข"
                    class="w-8 h-8 rounded-lg flex items-center justify-center border border-slate-100 hover:border-amber-400 text-slate-400 hover:text-amber-500 transition-all cursor-pointer">
                    <span class="material-icons text-base">edit</span>
                  </button>
                </div>
              </td>
            </tr>
            <tr *ngIf="siteQuotas().length === 0 && !isSiteLoading()">
              <td colspan="8" class="py-10 text-center text-slate-400">
                <span class="material-icons text-3xl mb-1">inventory_2</span>
                <p class="font-bold">ยังไม่ได้ตั้งโควต้าลาน</p>
                <button *ngIf="canUpdate" type="button" (click)="openSiteQuotaModal()"
                  class="mt-3 px-4 py-2 bg-amber-400 hover:bg-amber-500 text-white font-bold rounded-xl text-xs">
                  ตั้งโควต้าลาน
                </button>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>

    <!-- Summary cards -->
    <div class="grid grid-cols-2 lg:grid-cols-4 gap-4 mb-6">
      <div class="animate-fade-in bg-white/95 dark:bg-slate-900/95 rounded-2xl p-5 shadow-xl border border-slate-100/50">
        <div class="w-10 h-10 rounded-xl flex items-center justify-center mb-3 bg-sky-50 text-sky-500">
          <span class="material-icons">apartment</span>
        </div>
        <h4 class="text-slate-400 text-xs font-bold uppercase tracking-wider mb-1">Client ที่ได้โควต้า</h4>
        <div class="text-2xl font-black text-slate-800 dark:text-slate-100">{{ clientSummary().clientCount | number }}</div>
        <p class="text-[11px] text-slate-400">{{ clientSummary().rowCount | number }} แถว (ราย Client × ประเภทรถ)</p>
      </div>
      <div class="animate-fade-in bg-white/95 dark:bg-slate-900/95 rounded-2xl p-5 shadow-xl border border-slate-100/50">
        <div class="w-10 h-10 rounded-xl flex items-center justify-center mb-3 bg-amber-50 text-amber-500">
          <span class="material-icons">assignment_turned_in</span>
        </div>
        <h4 class="text-slate-400 text-xs font-bold uppercase tracking-wider mb-1">แจกแล้ว (อนุมัติ)</h4>
        <div class="text-2xl font-black text-slate-800 dark:text-slate-100">{{ clientSummary().quotaApproved | number }}</div>
      </div>
      <div class="animate-fade-in bg-white/95 dark:bg-slate-900/95 rounded-2xl p-5 shadow-xl border border-slate-100/50">
        <div class="w-10 h-10 rounded-xl flex items-center justify-center mb-3 bg-violet-50 text-violet-500">
          <span class="material-icons">directions_car</span>
        </div>
        <h4 class="text-slate-400 text-xs font-bold uppercase tracking-wider mb-1">ใช้แล้ว</h4>
        <div class="text-2xl font-black text-slate-800 dark:text-slate-100">{{ clientSummary().quotaUsed | number }}</div>
      </div>
      <div class="animate-fade-in bg-white/95 dark:bg-slate-900/95 rounded-2xl p-5 shadow-xl border border-slate-100/50">
        <div class="w-10 h-10 rounded-xl flex items-center justify-center mb-3 bg-emerald-50 text-emerald-500">
          <span class="material-icons">savings</span>
        </div>
        <h4 class="text-slate-400 text-xs font-bold uppercase tracking-wider mb-1">คงเหลือที่ Client</h4>
        <div class="text-2xl font-black text-slate-800 dark:text-slate-100">{{ clientSummary().quotaRemaining | number }}</div>
      </div>
    </div>

    <!-- Client quota table -->
    <div class="animate-fade-in bg-white/95 dark:bg-slate-900/95 backdrop-blur-sm rounded-[2rem] shadow-2xl border border-slate-100/50 overflow-hidden">
      <div class="p-6 border-b border-slate-100/50 flex flex-col xl:flex-row xl:items-center justify-between gap-4">
        <h3 class="text-lg font-bold text-slate-800 dark:text-slate-100 flex items-center gap-2 shrink-0">
          <span class="material-icons text-amber-500">apartment</span>
          โควต้าราย Client
        </h3>
        <div class="flex flex-col md:flex-row items-stretch md:items-center gap-3 w-full xl:max-w-3xl">
          <select [(ngModel)]="filterVehicleTypeId" (ngModelChange)="onClientSearch()"
            class="bg-slate-50 dark:bg-slate-800 border border-slate-200 dark:border-slate-700 text-sm rounded-xl font-bold px-3 py-2.5 outline-none focus:ring-2 focus:ring-amber-200">
            <option [ngValue]="0">ทุกประเภทรถ</option>
            <option *ngFor="let q of siteQuotas()" [ngValue]="q.vehicleTypeId">{{ q.vehicleTypeName || q.vehicleTypeId }}</option>
          </select>
          <select [(ngModel)]="filterManagedBy" (ngModelChange)="onClientSearch()"
            class="bg-slate-50 dark:bg-slate-800 border border-slate-200 dark:border-slate-700 text-sm rounded-xl font-bold px-3 py-2.5 outline-none focus:ring-2 focus:ring-amber-200">
            <option value="">ผู้ดูแลทั้งหมด</option>
            <option *ngFor="let o of managedByOptions" [value]="o.value">{{ o.label }}</option>
          </select>
          <div class="relative flex-1 flex">
            <span class="absolute left-3 top-1/2 -translate-y-1/2 material-icons text-slate-400 text-[20px]">search</span>
            <input type="text" placeholder="ค้นหาชื่อ Client / เลขภาษี / ID..."
              [(ngModel)]="clientSearch" (keyup.enter)="onClientSearch()"
              class="w-full pl-10 pr-4 py-2.5 bg-slate-50 dark:bg-slate-800 rounded-xl border border-slate-100 dark:border-slate-700 text-sm font-medium focus:ring-2 focus:ring-amber-200 focus:outline-none" />
          </div>
          <button type="button" (click)="onClientSearch()"
            class="px-4 py-2.5 bg-amber-400 hover:bg-amber-500 text-white font-bold rounded-xl transition-all">
            ค้นหา
          </button>
          <button *ngIf="hasClientFilter" type="button" (click)="clearClientFilters()" title="ล้างตัวกรอง"
            class="px-3 py-2.5 rounded-xl border border-slate-200 text-slate-500 hover:text-rose-500 hover:border-rose-300 transition-all flex items-center justify-center">
            <span class="material-icons text-[18px]">filter_alt_off</span>
          </button>
        </div>
      </div>

      <div class="overflow-x-auto min-h-[300px] relative custom-scrollbar">
        <table class="w-full text-left border-collapse" [class.opacity-50]="isClientLoading()">
          <thead class="sticky top-0 z-20 bg-white/95 dark:bg-slate-900/95 border-b border-slate-100/50">
            <tr class="text-xs font-bold text-slate-400 uppercase tracking-widest">
              <th class="p-4">Client</th>
              <th class="p-4">ประเภทรถ</th>
              <th class="p-4 text-right">อนุมัติ</th>
              <th class="p-4 text-right">ใช้แล้ว</th>
              <th class="p-4 w-[200px]">คงเหลือ</th>
              <th class="p-4">ผู้ดูแล</th>
              <th class="p-4 text-center w-[220px]">จัดการ</th>
            </tr>
          </thead>
          <tbody class="divide-y divide-slate-50 dark:divide-slate-800">
            <tr *ngFor="let row of clientRows(); trackBy: trackClientRow"
              class="hover:bg-slate-50/50 dark:hover:bg-slate-800/50 transition-all">
              <td class="p-4">
                <span class="text-sm font-bold text-slate-700 dark:text-slate-200">{{ row.clientName || '—' }}</span>
                <p class="text-xs text-slate-400 mt-0.5 font-mono">Client #{{ row.clientId }}</p>
              </td>
              <td class="p-4">
                <span class="inline-flex px-2 py-0.5 rounded-lg text-[11px] font-semibold bg-amber-50 text-amber-700 dark:bg-amber-900/30 dark:text-amber-300">
                  {{ row.vehicleTypeName || row.vehicleTypeId }}
                </span>
              </td>
              <td class="p-4 text-right font-bold">{{ row.quotaApproved | number }}</td>
              <td class="p-4 text-right">{{ row.quotaUsed | number }}</td>
              <td class="p-4">
                <div class="flex items-center justify-between text-xs mb-1">
                  <span class="font-black" [ngClass]="row.quotaRemaining > 0 ? 'text-emerald-600' : 'text-slate-400'">
                    {{ row.quotaRemaining | number }}
                  </span>
                  <span class="text-slate-400">ใช้ {{ usagePercent(row.quotaUsed, row.quotaApproved) }}%</span>
                </div>
                <div class="h-1.5 rounded-full bg-slate-100 dark:bg-slate-800 overflow-hidden">
                  <div class="h-full rounded-full transition-all"
                    [ngClass]="usagePercent(row.quotaUsed, row.quotaApproved) >= 90 ? 'bg-rose-400' : 'bg-amber-400'"
                    [style.width.%]="usagePercent(row.quotaUsed, row.quotaApproved)"></div>
                </div>
              </td>
              <td class="p-4">
                <span class="inline-flex px-2.5 py-1 rounded-full text-xs font-semibold"
                  [ngClass]="row.managedBy === 'client_self'
                    ? 'bg-violet-50 text-violet-700 dark:bg-violet-900/30 dark:text-violet-300'
                    : 'bg-slate-100 text-slate-600 dark:bg-slate-700 dark:text-slate-300'">
                  {{ managedByLabel(row.managedBy) }}
                </span>
              </td>
              <td class="p-4 text-center">
                <div class="inline-flex items-center gap-1.5">
                  <button type="button" (click)="openClientHistory(row)" title="ดูประวัติ"
                    class="w-8 h-8 rounded-lg flex items-center justify-center border border-slate-100 hover:border-sky-400 text-slate-400 hover:text-sky-500 transition-all cursor-pointer">
                    <span class="material-icons text-base">history</span>
                  </button>
                  <ng-container *ngIf="canUpdate">
                    <button type="button" (click)="openAllocateModal(row)" title="เพิ่มโควต้า"
                      class="w-8 h-8 rounded-lg flex items-center justify-center border border-slate-100 hover:border-emerald-400 text-slate-400 hover:text-emerald-500 transition-all cursor-pointer">
                      <span class="material-icons text-base">add_circle_outline</span>
                    </button>
                    <button type="button" (click)="openEditClientModal(row)" title="แก้ไข"
                      class="w-8 h-8 rounded-lg flex items-center justify-center border border-slate-100 hover:border-amber-400 text-slate-400 hover:text-amber-500 transition-all cursor-pointer">
                      <span class="material-icons text-base">edit</span>
                    </button>
                    <button type="button" (click)="reclaimUnusedClientQuota(row)" title="คืนส่วนเหลือกลับลาน"
                      [disabled]="row.quotaRemaining <= 0"
                      class="w-8 h-8 rounded-lg flex items-center justify-center border border-slate-100 hover:border-orange-400 text-slate-400 hover:text-orange-500 transition-all cursor-pointer disabled:opacity-30 disabled:cursor-not-allowed">
                      <span class="material-icons text-base">undo</span>
                    </button>
                    <button type="button" (click)="cancelClientQuota(row)" title="ยกเลิกโควต้า"
                      class="w-8 h-8 rounded-lg flex items-center justify-center border border-slate-100 hover:border-rose-400 text-slate-400 hover:text-rose-500 transition-all cursor-pointer">
                      <span class="material-icons text-base">delete_outline</span>
                    </button>
                  </ng-container>
                </div>
              </td>
            </tr>
            <tr *ngIf="clientRows().length === 0 && !isClientLoading()">
              <td colspan="7" class="py-20 text-center text-slate-400">
                <span class="material-icons text-4xl mb-2">search_off</span>
                <p class="font-bold">{{ hasClientFilter ? 'ไม่พบ Client ตามเงื่อนไข' : 'ยังไม่มีการแจกโควต้าให้ Client' }}</p>
              </td>
            </tr>
          </tbody>
        </table>
        <div *ngIf="isClientLoading()" class="absolute inset-0 flex items-center justify-center">
          <span class="material-icons animate-spin text-amber-400 text-4xl">autorenew</span>
        </div>
      </div>

      <div class="px-6 py-4 border-t border-slate-100/50 flex flex-col md:flex-row items-center justify-between gap-4">
        <div class="flex items-center gap-4 text-sm text-slate-500 font-medium">
          <span>แสดง {{ startItemIndex | number }} - {{ endItemIndex | number }} จาก {{ clientTotal() | number }} รายการ</span>
          <select [ngModel]="clientPageSize()" (ngModelChange)="onClientPageSizeChange($event)"
            class="bg-slate-50 dark:bg-slate-800 border border-slate-200 text-sm rounded-lg font-bold px-2 py-1 outline-none">
            <option *ngFor="let size of pageSizeOptions" [ngValue]="size">{{ size }} / หน้า</option>
          </select>
        </div>
        <div class="flex items-center gap-2">
          <button type="button" (click)="setClientPage(clientPage() - 1)" [disabled]="clientPage() === 1"
            class="w-9 h-9 flex items-center justify-center rounded-lg border border-slate-200 hover:text-amber-500 disabled:opacity-30">
            <span class="material-icons text-sm">chevron_left</span>
          </button>
          <button type="button" *ngFor="let page of pagesArray" (click)="setClientPage(page)"
            class="w-9 h-9 flex items-center justify-center rounded-lg text-sm font-bold"
            [ngClass]="page === clientPage() ? 'bg-amber-400 text-white' : 'text-slate-600 hover:bg-amber-50'">
            {{ page }}
          </button>
          <button type="button" (click)="setClientPage(clientPage() + 1)"
            [disabled]="clientPage() === clientTotalPages() || clientTotalPages() === 0"
            class="w-9 h-9 flex items-center justify-center rounded-lg border border-slate-200 hover:text-amber-500 disabled:opacity-30">
            <span class="material-icons text-sm">chevron_right</span>
          </button>
        </div>
      </div>
    </div>
  </ng-container>
</div>

<!-- ===== Modal: site quota ===== -->
<div *ngIf="isSiteModalOpen()"
  class="fixed inset-0 z-50 flex items-center justify-center p-4 bg-slate-900/60 backdrop-blur-sm animate-fade-in"
  (click)="closeSiteQuotaModal()">
  <div class="w-full max-w-lg bg-white dark:bg-slate-900 rounded-[2rem] shadow-2xl overflow-hidden"
    (click)="$event.stopPropagation()">
    <div class="px-6 py-5 border-b border-slate-100 dark:border-slate-800 flex items-center justify-between">
      <div>
        <h3 class="text-lg font-bold text-slate-800 dark:text-slate-100">
          {{ quotaForm.id ? 'แก้ไขโควต้าลาน' : 'ตั้งโควต้าลาน' }}
        </h3>
        <p class="text-xs text-slate-400">{{ selectedSiteName }}</p>
      </div>
      <button type="button" (click)="closeSiteQuotaModal()" class="text-slate-400 hover:text-rose-500">
        <span class="material-icons">close</span>
      </button>
    </div>
    <div class="p-6 space-y-4">
      <div>
        <label class="block text-xs font-bold text-slate-500 mb-1">ประเภทรถ <span class="text-rose-500">*</span></label>
        <select [(ngModel)]="quotaForm.vehicleTypeId" (ngModelChange)="onVehicleTypeChange()" [disabled]="!!quotaForm.id"
          class="w-full bg-slate-50 dark:bg-slate-800 border border-slate-200 dark:border-slate-700 rounded-xl px-3 py-2.5 font-bold outline-none focus:ring-2 focus:ring-amber-200 disabled:opacity-60">
          <option [ngValue]="0">— เลือกประเภทรถ —</option>
          <option *ngFor="let vt of siteModalVehicleTypes" [ngValue]="vt.id">{{ vt.name }}</option>
        </select>
        <p *ngIf="!quotaForm.id && siteModalVehicleTypes.length === 0" class="text-xs text-rose-500 mt-1">
          ทุกประเภทรถตั้งโควต้าแล้ว — แก้ไขจากตารางแทน
        </p>
      </div>
      <div>
        <label class="block text-xs font-bold text-slate-500 mb-1">แพ็กเกจจอดฟรี (ไม่บังคับ)</label>
        <select [(ngModel)]="quotaForm.subscriptionId"
          class="w-full bg-slate-50 dark:bg-slate-800 border border-slate-200 dark:border-slate-700 rounded-xl px-3 py-2.5 outline-none focus:ring-2 focus:ring-amber-200">
          <option [ngValue]="null">— ไม่ระบุ —</option>
          <option *ngFor="let s of filteredFreeSubscriptions" [ngValue]="s.id">{{ s.name }}</option>
        </select>
      </div>
      <div class="grid grid-cols-2 gap-4">
        <div>
          <label class="block text-xs font-bold text-slate-500 mb-1">จำนวนอนุมัติ <span class="text-rose-500">*</span></label>
          <input type="number" min="0" [(ngModel)]="quotaForm.quotaApproved"
            class="w-full bg-slate-50 dark:bg-slate-800 border border-slate-200 dark:border-slate-700 rounded-xl px-3 py-2.5 font-bold outline-none focus:ring-2 focus:ring-amber-200" />
        </div>
        <div>
          <label class="block text-xs font-bold text-slate-500 mb-1">สถานะ</label>
          <select [(ngModel)]="quotaForm.status"
            class="w-full bg-slate-50 dark:bg-slate-800 border border-slate-200 dark:border-slate-700 rounded-xl px-3 py-2.5 outline-none focus:ring-2 focus:ring-amber-200">
            <option *ngFor="let o of statusOptions" [value]="o.value">{{ o.label }}</option>
          </select>
        </div>
      </div>
    </div>
    <div class="px-6 py-4 border-t border-slate-100 dark:border-slate-800 flex justify-end gap-3">
      <button type="button" (click)="closeSiteQuotaModal()"
        class="px-5 py-2.5 rounded-xl border border-slate-200 font-bold text-slate-500 hover:bg-slate-50">ยกเลิก</button>
      <button type="button" (click)="onSaveQuota()" [disabled]="isSaving()"
        class="px-5 py-2.5 rounded-xl bg-amber-400 hover:bg-amber-500 text-white font-bold disabled:opacity-50 flex items-center gap-2">
        <span class="material-icons text-[18px]">save</span>
        บันทึก
      </button>
    </div>
  </div>
</div>

<!-- ===== Modal: allocate ===== -->
<div *ngIf="isAllocateModalOpen()"
  class="fixed inset-0 z-50 flex items-center justify-center p-4 bg-slate-900/60 backdrop-blur-sm animate-fade-in"
  (click)="closeAllocateModal()">
  <div class="w-full max-w-2xl bg-white dark:bg-slate-900 rounded-[2rem] shadow-2xl overflow-hidden flex flex-col max-h-[90vh]"
    (click)="$event.stopPropagation()">
    <div class="px-6 py-5 border-b border-slate-100 dark:border-slate-800 flex items-center justify-between">
      <div>
        <h3 class="text-lg font-bold text-slate-800 dark:text-slate-100">
          {{ allocateLocked ? 'เพิ่มโควต้าให้ Client' : 'แจกโควต้าให้ Client' }}
        </h3>
        <p class="text-xs text-slate-400">จำนวนที่แจกจะหักจาก pool ของลาน {{ selectedSiteName }}</p>
      </div>
      <button type="button" (click)="closeAllocateModal()" class="text-slate-400 hover:text-rose-500">
        <span class="material-icons">close</span>
      </button>
    </div>

    <div class="p-6 space-y-5 overflow-y-auto custom-scrollbar">
      <!-- Client picker -->
      <div>
        <label class="block text-xs font-bold text-slate-500 mb-1">Client (บริษัทผู้เช่า) <span class="text-rose-500">*</span></label>

        <div *ngIf="allocateClient() as picked"
          class="flex items-center justify-between gap-3 px-4 py-3 rounded-xl border border-amber-300 bg-amber-50/60 dark:bg-amber-900/20">
          <div class="min-w-0">
            <p class="font-bold text-slate-700 dark:text-slate-100 truncate">{{ picked.name }}</p>
            <p class="text-xs text-slate-500">
              Client #{{ picked.id }}
              <span *ngIf="picked.taxId"> · ภาษี {{ picked.taxId }}</span>
              <span *ngIf="picked.quotaApproved > 0"> · ถืออยู่ {{ picked.quotaApproved | number }} (ใช้ {{ picked.quotaUsed | number }})</span>
            </p>
          </div>
          <button *ngIf="!allocateLocked" type="button" (click)="clearPickedClient()"
            class="shrink-0 px-3 py-1.5 rounded-lg border border-slate-200 bg-white text-xs font-bold text-slate-500 hover:text-amber-600">
            เปลี่ยน
          </button>
        </div>

        <ng-container *ngIf="!allocateClient()">
          <div class="relative">
            <span class="absolute left-3 top-1/2 -translate-y-1/2 material-icons text-slate-400 text-[20px]">search</span>
            <input type="text" placeholder="พิมพ์ชื่อบริษัท / เลขภาษี / ผู้ติดต่อ / ID"
              [(ngModel)]="clientPickerSearch" (ngModelChange)="onClientPickerSearchChange()"
              class="w-full pl-10 pr-4 py-2.5 bg-slate-50 dark:bg-slate-800 rounded-xl border border-slate-200 dark:border-slate-700 text-sm font-medium focus:ring-2 focus:ring-amber-200 focus:outline-none" />
          </div>
          <div class="mt-2 border border-slate-100 dark:border-slate-800 rounded-xl max-h-60 overflow-y-auto custom-scrollbar divide-y divide-slate-50 dark:divide-slate-800">
            <div *ngIf="isClientOptionsLoading()" class="py-6 text-center text-slate-400 text-xs">
              <span class="material-icons animate-spin text-amber-400">autorenew</span>
            </div>
            <ng-container *ngIf="!isClientOptionsLoading()">
              <button type="button" *ngFor="let opt of clientOptions(); trackBy: trackOption" (click)="pickClient(opt)"
                class="w-full text-left px-4 py-2.5 hover:bg-amber-50 dark:hover:bg-slate-800 transition-all flex items-center justify-between gap-3">
                <div class="min-w-0">
                  <p class="font-bold text-slate-700 dark:text-slate-200 truncate">{{ opt.name }}</p>
                  <p class="text-[11px] text-slate-400 truncate">
                    #{{ opt.id }}<span *ngIf="opt.taxId"> · {{ opt.taxId }}</span><span *ngIf="opt.contact"> · {{ opt.contact }}</span><span *ngIf="opt.telephone"> · {{ opt.telephone }}</span>
                  </p>
                </div>
                <span *ngIf="opt.quotaApproved > 0"
                  class="shrink-0 inline-flex px-2 py-0.5 rounded-lg text-[11px] font-semibold bg-emerald-50 text-emerald-700">
                  ถือ {{ opt.quotaApproved | number }}
                </span>
              </button>
              <p *ngIf="clientOptions().length === 0" class="py-6 text-center text-slate-400 text-xs">ไม่พบ Client ในลานนี้</p>
              <p *ngIf="clientOptions().length >= 30" class="py-2 text-center text-[11px] text-slate-400">
                แสดง 30 รายการแรก — พิมพ์คำค้นเพื่อกรองเพิ่ม
              </p>
            </ng-container>
          </div>
        </ng-container>
      </div>

      <!-- Vehicle type (pool) -->
      <div>
        <label class="block text-xs font-bold text-slate-500 mb-1">ประเภทรถ (pool ของลาน) <span class="text-rose-500">*</span></label>
        <div class="grid grid-cols-1 sm:grid-cols-2 gap-2">
          <button type="button" *ngFor="let q of allocatableSiteQuotas"
            (click)="allocateVehicleTypeId = q.vehicleTypeId"
            [disabled]="allocateLocked && allocateVehicleTypeId !== q.vehicleTypeId"
            class="text-left px-4 py-3 rounded-xl border transition-all disabled:opacity-40 disabled:cursor-not-allowed"
            [ngClass]="allocateVehicleTypeId === q.vehicleTypeId
              ? 'border-amber-400 bg-amber-50 dark:bg-amber-900/20 ring-2 ring-amber-200'
              : 'border-slate-200 dark:border-slate-700 hover:border-amber-300'">
            <p class="font-bold text-slate-700 dark:text-slate-200">{{ q.vehicleTypeName || q.vehicleTypeId }}</p>
            <p class="text-xs" [ngClass]="q.quotaRemainingPool > 0 ? 'text-emerald-600' : 'text-rose-500'">
              เหลือแจกได้ {{ q.quotaRemainingPool | number }} / {{ q.quotaApproved | number }}
            </p>
          </button>
        </div>
      </div>

      <div class="grid grid-cols-1 sm:grid-cols-2 gap-4">
        <div>
          <label class="block text-xs font-bold text-slate-500 mb-1">จำนวนที่แจกเพิ่ม <span class="text-rose-500">*</span></label>
          <input type="number" min="1" [(ngModel)]="allocateAdditionalQuota"
            class="w-full bg-slate-50 dark:bg-slate-800 border border-slate-200 dark:border-slate-700 rounded-xl px-3 py-2.5 font-bold outline-none focus:ring-2 focus:ring-amber-200" />
          <p *ngIf="allocatePool as pool" class="text-xs mt-1"
            [ngClass]="allocateAdditionalQuota > pool.quotaRemainingPool ? 'text-rose-500 font-bold' : 'text-slate-400'">
            pool เหลือหลังแจก {{ pool.quotaRemainingPool - (allocateAdditionalQuota || 0) | number }}
          </p>
        </div>
        <div>
          <label class="block text-xs font-bold text-slate-500 mb-1">ผู้ดูแลโควต้า</label>
          <select [(ngModel)]="allocateManagedBy"
            class="w-full bg-slate-50 dark:bg-slate-800 border border-slate-200 dark:border-slate-700 rounded-xl px-3 py-2.5 outline-none focus:ring-2 focus:ring-amber-200">
            <option *ngFor="let o of managedByOptions" [value]="o.value">{{ o.label }}</option>
          </select>
        </div>
      </div>
    </div>

    <div class="px-6 py-4 border-t border-slate-100 dark:border-slate-800 flex justify-end gap-3">
      <button type="button" (click)="closeAllocateModal()"
        class="px-5 py-2.5 rounded-xl border border-slate-200 font-bold text-slate-500 hover:bg-slate-50">ยกเลิก</button>
      <button type="button" (click)="onAllocate()"
        [disabled]="isAllocating() || !allocateClient() || !allocateVehicleTypeId"
        class="px-5 py-2.5 rounded-xl bg-amber-400 hover:bg-amber-500 text-white font-bold disabled:opacity-50 flex items-center gap-2">
        <span class="material-icons text-[18px]">share</span>
        แจกโควต้า
      </button>
    </div>
  </div>
</div>

<!-- ===== Modal: edit client quota ===== -->
<div *ngIf="isEditModalOpen() && editRow() as row"
  class="fixed inset-0 z-50 flex items-center justify-center p-4 bg-slate-900/60 backdrop-blur-sm animate-fade-in"
  (click)="closeEditClientModal()">
  <div class="w-full max-w-lg bg-white dark:bg-slate-900 rounded-[2rem] shadow-2xl overflow-hidden"
    (click)="$event.stopPropagation()">
    <div class="px-6 py-5 border-b border-slate-100 dark:border-slate-800 flex items-center justify-between">
      <div class="min-w-0">
        <h3 class="text-lg font-bold text-slate-800 dark:text-slate-100">แก้ไขโควต้า Client</h3>
        <p class="text-xs text-slate-400 truncate">{{ row.clientName || row.clientId }} · {{ row.vehicleTypeName || row.vehicleTypeId }}</p>
      </div>
      <button type="button" (click)="closeEditClientModal()" class="text-slate-400 hover:text-rose-500">
        <span class="material-icons">close</span>
      </button>
    </div>
    <div class="p-6 space-y-4">
      <div class="grid grid-cols-3 gap-3 text-center">
        <div class="rounded-xl bg-slate-50 dark:bg-slate-800 p-3">
          <p class="text-[11px] text-slate-400 font-bold">อนุมัติเดิม</p>
          <p class="text-lg font-black text-slate-700 dark:text-slate-100">{{ row.quotaApproved | number }}</p>
        </div>
        <div class="rounded-xl bg-slate-50 dark:bg-slate-800 p-3">
          <p class="text-[11px] text-slate-400 font-bold">ใช้แล้ว</p>
          <p class="text-lg font-black text-slate-700 dark:text-slate-100">{{ row.quotaUsed | number }}</p>
        </div>
        <div class="rounded-xl bg-slate-50 dark:bg-slate-800 p-3">
          <p class="text-[11px] text-slate-400 font-bold">pool ลานเหลือ</p>
          <p class="text-lg font-black text-emerald-600">{{ editPool?.quotaRemainingPool ?? 0 | number }}</p>
        </div>
      </div>
      <div>
        <label class="block text-xs font-bold text-slate-500 mb-1">จำนวนอนุมัติใหม่ <span class="text-rose-500">*</span></label>
        <input type="number" [min]="row.quotaUsed" [(ngModel)]="editClientQuotaApproved"
          class="w-full bg-slate-50 dark:bg-slate-800 border border-slate-200 dark:border-slate-700 rounded-xl px-3 py-2.5 font-bold outline-none focus:ring-2 focus:ring-amber-200" />
        <p class="text-xs mt-1"
          [ngClass]="editDelta > 0 ? 'text-amber-600' : editDelta < 0 ? 'text-emerald-600' : 'text-slate-400'">
          <ng-container *ngIf="editDelta > 0">เพิ่ม {{ editDelta | number }} — หักจาก pool ลาน</ng-container>
          <ng-container *ngIf="editDelta < 0">ลด {{ -editDelta | number }} — คืนกลับ pool ลาน</ng-container>
          <ng-container *ngIf="editDelta === 0">ไม่เปลี่ยนจำนวน · ลดได้ต่ำสุด {{ row.quotaUsed | number }}</ng-container>
        </p>
      </div>
      <div>
        <label class="block text-xs font-bold text-slate-500 mb-1">ผู้ดูแลโควต้า</label>
        <select [(ngModel)]="editClientManagedBy"
          class="w-full bg-slate-50 dark:bg-slate-800 border border-slate-200 dark:border-slate-700 rounded-xl px-3 py-2.5 outline-none focus:ring-2 focus:ring-amber-200">
          <option *ngFor="let o of managedByOptions" [value]="o.value">{{ o.label }}</option>
        </select>
      </div>
    </div>
    <div class="px-6 py-4 border-t border-slate-100 dark:border-slate-800 flex justify-end gap-3">
      <button type="button" (click)="closeEditClientModal()"
        class="px-5 py-2.5 rounded-xl border border-slate-200 font-bold text-slate-500 hover:bg-slate-50">ยกเลิก</button>
      <button type="button" (click)="onUpdateClientQuota()" [disabled]="isUpdatingClient()"
        class="px-5 py-2.5 rounded-xl bg-amber-400 hover:bg-amber-500 text-white font-bold disabled:opacity-50 flex items-center gap-2">
        <span class="material-icons text-[18px]">save</span>
        บันทึก
      </button>
    </div>
  </div>
</div>

<app-modal-admin-activity-history *ngIf="showActivityHistory"
  [entityType]="historyEntityType"
  [entityId]="historyEntityId"
  [title]="historyTitle"
  [subtitle]="historySubtitle"
  (close)="closeActivityHistory()">
</app-modal-admin-activity-history>

<app-pss-confirm-modal *ngIf="showConfirm"
  [title]="confirmTitle"
  [message]="confirmMessage"
  [highlight]="confirmHighlight"
  [messageSuffix]="confirmMessageSuffix"
  confirmLabel="ใช่"
  cancelLabel="ไม่"
  [variant]="confirmVariant"
  [icon]="confirmIcon"
  [loading]="confirmLoading"
  [showIrreversibleNote]="confirmVariant === 'danger'"
  (confirm)="onConfirmYes()"
  (cancel)="onConfirmNo()">
</app-pss-confirm-modal>
